class FreeGiftHandler {
  constructor() {
    this.settings = window.FREE_GIFT_SETTINGS || {};
    if (!this.settings.enabled) return;
    this.init();
  }

  init() {
    // Check on initial load
    this.checkCart();

    // Listen for cart updates
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      // Avoid infinite loop if the update was triggered by us
      if (event.source === 'free-gift-handler') return;
      this.checkCart(event.cartData);
    });
  }

  checkCart(cartData) {
    if (cartData) {
      this.handleCartLogic(cartData);
    } else {
      fetch(window.routes.cart_url + '.js')
        .then((response) => response.json())
        .then((cart) => {
          this.handleCartLogic(cart);
        })
        .catch((e) => console.error('Error fetching cart:', e));
    }
  }

  isWithinDateRange() {
    const now = new Date();
    const start = this.settings.startDate ? new Date(this.settings.startDate) : null;
    const end = this.settings.endDate ? new Date(this.settings.endDate) : null;

    if (start && now < start) return false;
    if (end && now > end) return false;
    return true;
  }

  handleCartLogic(cart) {
    if (!this.settings.giftVariantId) return;

    // Safety check: if cart or items are missing, fetch the full cart
    if (!cart || !cart.items) {
      this.checkCart(); // Will fetch cart.js
      return;
    }

    const giftInCart = cart.items.find((item) => item.variant_id === this.settings.giftVariantId);

    // If outside date range, remove gift if present, and do nothing else
    if (!this.isWithinDateRange()) {
      if (giftInCart) {
        this.removeGift(giftInCart.key);
      }
      return;
    }

    let shouldHaveGift = false;

    if (this.settings.triggerType === 'threshold') {
      shouldHaveGift = cart.total_price >= this.settings.threshold;
    } else if (this.settings.triggerType === 'product') {
      shouldHaveGift = cart.items.some((item) => item.variant_id === this.settings.triggerVariantId);
    }

    if (shouldHaveGift && !giftInCart) {
      this.addGift();
    } else if (!shouldHaveGift && giftInCart) {
      this.removeGift(giftInCart.key);
    }
  }

  addGift() {
    const body = JSON.stringify({
      items: [{
        id: this.settings.giftVariantId,
        quantity: 1
      }]
    });

    fetch(window.routes.cart_add_url, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then((response) => {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'free-gift-handler',
          cartData: response
        });
      })
      .catch((e) => console.error('Error adding gift:', e));
  }

  removeGift(lineItemKey) {
    const body = JSON.stringify({
      id: lineItemKey,
      quantity: 0
    });

    fetch(window.routes.cart_change_url, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then((response) => {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'free-gift-handler',
          cartData: response
        });
      })
      .catch((e) => console.error('Error removing gift:', e));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new FreeGiftHandler();
});
